import React from 'react';
import meetingState from '../../../../data/constants/meetingState';
import {useEvent} from '../../../../data/hooks/eventHooks';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import {useMeeting} from '../../../../data/hooks/meeting/useMeeting';
import WaitWhileBusy from '../../../WaitWhileBusy';
import ButtonLink from '../../../elements/ButtonLink';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import {dialogAlert, dialogConfirm} from '../../../elements/Dialog/dialogs';
import EventContentHeader from '../../../elements/headers/EventContentHeader';
import Scrollable from '../../../elements/Scrollable';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Input from '../../../elements/forms/Input';
import Validate from '../../../validate/Validate';
import Screen from '../../Screen';
import RescheduleOption from './RescheduleOption/RescheduleOption';

export class EventUserMeetingRejection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: null,
            customMessage: '',
        };
    }
    componentDidMount() {
        this.focusOnFirstInput();
    }
    componentDidUpdate() {
        this.focusOnFirstInput();
    }
    render() {
        let {event, meeting, i18n} = this.props,
            content;

        if (!this.state.reason) {
            // Allow the user to pick the reason
            content = (
                <ul className="list">
                    <RescheduleOption event={event} meeting={meeting} i18n={i18n} />
                    <ListItem
                        className="clickable"
                        icon="img/event_schedules.png"
                        iconColor={event.settings.secondary_color}
                        iconSmall
                        next
                        onClick={this.handleSelectReason.bind(this, app.api.meetings.REJECTION_REASONS.UNAVAILABLE, false)}>
                        <div className="text main marginTop">{i18n['label.unavailable.at.that.time']}</div>
                    </ListItem>
                    <ListItem
                        className="clickable"
                        icon="img/reject_icon.png"
                        iconColor={event.settings.secondary_color}
                        iconSmall
                        next
                        onClick={this.handleSelectReason.bind(this, app.api.meetings.REJECTION_REASONS.UNINTERESTED, false)}>
                        <div className="text main marginTop">{i18n['label.not.interested']}</div>
                    </ListItem>
                    <ListItem
                        className="clickable"
                        icon="img/edit.png"
                        iconColor={event.settings.secondary_color}
                        iconSmall
                        next
                        onClick={this.handleSelectReason.bind(this, app.api.meetings.REJECTION_REASONS.OTHER, false)}>
                        <div className="text main marginTop">{i18n['label.other']}</div>
                    </ListItem>
                </ul>
            );
        } else {
            let justificationTitle,
                defaultCustomMessage = '';
            switch (this.state.reason) {
                case app.api.meetings.REJECTION_REASONS.UNAVAILABLE:
                    justificationTitle = i18n['label.unavailable.at.that.time'];
                    break;
                case app.api.meetings.REJECTION_REASONS.UNINTERESTED:
                    justificationTitle = i18n['label.not.interested'];
                    break;
                case app.api.meetings.REJECTION_REASONS.OTHER:
                    justificationTitle = i18n['label.other'];
                    break;
            }

            content = (
                <form className="content" onSubmit={this.handleSubmit.bind(this)}>
                    <h4>{justificationTitle}</h4>
                    <Input
                        name="message"
                        label={i18n['label.enter-custom-reason']}
                        type="textarea"
                        defaultValue={defaultCustomMessage}
                        rows={5}
                        value={this.state.customMessage}
                        onChange={this.handleChange.bind(this, 'customMessage')}
                    />
                    <ButtonLink type="submit" style={event._local.styles.button}>
                        {i18n['label.reject-meeting']}
                    </ButtonLink>
                </form>
            );
        }

        let header = (
            <div>
                <TopBarEvent event={event} returnURL={this.props.returnURL} meetings />
                <EventContentHeader>{i18n['label.choose-reason']}</EventContentHeader>
            </div>
        );

        return (
            <Screen header={header}>
                <Scrollable>{content}</Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({[field]: value});
    }
    handleSelectReason(reasonId) {
        this.setState({
            reason: reasonId,
        });
    }
    async handleSubmit(e) {
        e.preventDefault();
        let {reason} = this.state;

        if (_(app.api.meetings.REJECTION_REASONS).values().includes(reason)) {
            if (await dialogConfirm(this.props.i18n['label.confirm-reject-question'])) {
                app.api.meetings
                    .reject(this.props.meeting.id, reason, this.state.customMessage)
                    .catch(console.error)
                    .then(() => {
                        app.history.push(this.props.returnURL);
                    });
            }
        } else {
            await dialogAlert(this.props.i18n['msg.select.value']);
        }
    }
    focusOnFirstInput() {
        try {
            let input = document.querySelector('input[name="message"]');
            if (input) input.focus();
        } catch (e) {
            console.error(e);
        }
    }
}

export default props => {
    const {eventId, meetingId} = props.match.params,
        event = useEvent(eventId),
        meeting = useMeeting(eventId, meetingId),
        i18n = useI18n();

    return (
        <WaitWhileBusy>
            <Validate
                validate={state => {
                    let params = props.match.params;
                    let meeting = _(state.events[params.eventId].meetings.all).find(meeting => {
                        return meeting.id == params.meetingId;
                    });
                    if (!meeting) throw new Error('Meeting not found');
                    else if (meeting._myInvite) {
                        if (meeting._myInvite.state == meetingState.CANCELLED) throw new Error('You already declined this meeting');
                    } else if (meeting._state == meetingState.CANCELLED) {
                        throw new Error('Meeting already cancelled');
                    }
                }}>
                <EventUserMeetingRejection returnURL=".." {...props.match.params} event={event} meeting={meeting} i18n={i18n} />
            </Validate>
        </WaitWhileBusy>
    );
};
